import { h } from 'vue'
import { downloadFile } from 'complex-utils'
import { notice } from 'complex-plugin'
import { ComplexList, DefaultEdit, DictionaryData } from 'complex-data'
import litigationApi from '@/pages/index/api/litigation'
import { hearStatus, logStatus, logStatusSelectValueType, mediateStatus } from '@/pages/index/select/litigation'
import { buildDictionaryBySelect } from '@/config/dictionary'
import { listWidth } from '@/config/dictionary/config'
import { dict } from '@/pages/index/select/dict'
import { baseSwitch } from '@/pages/index/select'
import LayoutParse from '@/config/utils/layout'
import litigationLogFlowConfig, { toLitigationLog } from './litigationLogFlowConfig'
import config from '@/config'
import { uploadFile } from '@/pages/index/utils/file'
import { pushOperateLog } from '@/pages/index/utils/operateLog'

const litigationLogFlowConfigList = litigationLogFlowConfig.getList('0')
const getEditMod = function(key?: string) {
  const data: Record<string, {
    $target: 'edit'
  }> = {}
  const index = key === undefined ? 0 : litigationLogFlowConfigList.indexOf(key)
  for (let i = index; i < litigationLogFlowConfigList.length; i++) {
    const currentKey = litigationLogFlowConfigList[i]
    data[currentKey] = {
      $target: 'edit'
    }
  }
  return data
}

export class LitigationLog extends ComplexList {
  buildItem(postData: Record<PropertyKey, any>, payload: Record<PropertyKey, any>, originData: Record<string, unknown>, litigationStatus: logStatusSelectValueType) {
    return new Promise((resolve, reject) => {
      postData.overdueRecordId = payload.overdueRecordId
      postData.applyLitigationId = payload.applyLitigationId
      litigationApi.litigationLogBuild.require(postData).then((res) => {
        notice.showMsg(litigationStatus.label + '操作成功！', 'success')
        pushOperateLog(res.data.data as string, '提交' + litigationStatus.label, 'litigationRecord')
        this.$reloadData(true)!.finally(() => {
          resolve({ status: 'success' })
        })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  changeItem(postData: Record<string, unknown>, payload: Record<PropertyKey, any>, originData: Record<string, unknown>, litigationStatus: logStatusSelectValueType) {
    return new Promise((resolve, reject) => {
      postData.id = originData.id
      postData.litigationStatus = litigationStatus.value
      litigationApi.litigationLogChange.require(postData).then(() => {
        notice.showMsg(litigationStatus.label + '操作成功！', 'success')
        pushOperateLog(postData.id as string, '维护' + litigationStatus.label, 'litigationRecord').finally(() => {
          if (litigationStatus.process === 50) {
            pushOperateLog(postData.id as string, '发起申请执行流程', 'litigationRecord')
          }
        })
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
  exportData() {
    return new Promise((resolve, reject) => {
      litigationApi.litigationLogExport.require({
        ...this.$getSearch()
      }).then(res => {
        downloadFile(res.data.data)
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
}
const layoutParse = new LayoutParse(3, 9, 15)
const searchLayoutParse = new LayoutParse(4, 8, 16)

const litigationLog = new LitigationLog({
  name: '诉讼记录',
  prop: 'litigationLog',
  module: {
    pagination: true,
    search: {
      module: {
        dictionary: {
          layout: {
            default: searchLayoutParse.getData(4)
          },
          list: [
            buildDictionaryBySelect(dict.business_lines_green, {
              prop: 'itemname',
              name: '业务线',
              originProp: 'itemname',
              originFrom: 'local',
              mod: {
                search: {
                  $target: 'edit'
                }
              }
            }, {
              onlyLabel: true
            }),
            {
              prop: 'contractNumber',
              name: '合同号',
              originProp: 'contractNumber',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            buildDictionaryBySelect(dict.litigationJudgmentResultType, {
              prop: 'judgmentResultType',
              name: '判决结果',
              originProp: 'judgmentResultType',
              mod: {
                search: {
                  $target: 'edit'
                }
              }
            }),
            buildDictionaryBySelect(dict.LITIGATION_REQUEST_TYPE, {
              prop: 'litigationRequestType',
              name: '诉讼请求',
              originProp: 'litigationRequestType',
              mod: {
                search: {
                  $target: 'edit'
                }
              }
            }),
            buildDictionaryBySelect(dict.LITIGATION_TYPE, {
              prop: 'litigationType',
              name: '诉讼类型',
              originProp: 'litigationType',
              mod: {
                search: {
                  $target: 'edit'
                }
              }
            }),
            {
              prop: 'customerName',
              name: '承租人',
              originProp: 'customerName',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            {
              prop: 'vinNo',
              name: '车架号',
              originProp: 'vinNo',
              originFrom: 'local',
              mod: {
                search: {
                  $type: 'edit',
                  type: 'input',
                  option: {
                    maxLength: 100
                  }
                }
              }
            },
            buildDictionaryBySelect(hearStatus, {
              prop: 'hearStatus',
              name: '审理阶段',
              originProp: 'hearStatus',
              mod: {
                search: {
                  $target: 'edit'
                }
              }
            }),
            buildDictionaryBySelect(logStatus, {
              prop: 'litigationStatus',
              name: '诉讼状态',
              originProp: 'litigationStatus',
              mod: {
                search: {
                  $target: 'edit'
                }
              }
            }),
            {
              prop: 'filingCaseDateBegin',
              name: '立案时间',
              originProp: 'filingCaseDateBegin',
              originFrom: 'local',
              post(value, { targetData }) {
                if (value && (value as string[]).length === 2) {
                  targetData.filingCaseDateEnd = (value as string[])[1]
                  return (value as string[])[0]
                }
              },
              mod: {
                search: {
                  $type: 'edit',
                  type: 'dateRange',
                  option: {
                    show: 'YYYY/MM/DD'
                  }
                }
              }
            },
          ]
        }
      },
      menu: {
        list: []
      },
    },
    dictionary: {
      layout: {
        default: layoutParse.getData(3),
        finish: {
          grid: 24,
          label: 8,
          content: 16
        }
      },
      option: {},
      propData: {
        id: 'id'
      },
      list: [
        {
          prop: 'id',
          name: 'ID',
          originProp: 'id',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'applyLitigationId',
          name: '法诉申请ID',
          originProp: 'applyLitigationId',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'overdueRecordId',
          name: '逾期记录ID',
          originProp: 'overdueRecordId',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'code',
          name: '诉讼编号',
          originProp: 'code',
          originFrom: 'list',
          mod: {
            list: {
              width: 140,
              render(payload) {
                return h('span', {
                  class: 'local-main-link',
                  onClick() {
                    const key = payload.record.litigationStatus.process
                    toLitigationLog(payload.record.id, key, payload.record.overdueRecordId)
                  }
                }, payload.text)
              }
            }
          }
        },
        {
          prop: 'itemname',
          name: '业务线',
          originProp: 'itemname',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.businessLine
            }
          }
        },
        {
          prop: 'contractNumber',
          name: '合同编号',
          originProp: 'contractNumber',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.contractNumber
            }
          }
        },
        {
          prop: 'customerName',
          name: '承租人',
          originProp: 'customerName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'assureName',
          name: '担保人',
          originProp: 'assureName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'vinNo',
          name: '车架号',
          originProp: 'vinNo',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.vin
            }
          }
        },
        buildDictionaryBySelect(mediateStatus, {
          prop: 'mediateStatus',
          name: '调解状态',
          originProp: 'mediateStatus',
          mod: {
            list: {}
          }
        }),
        {
          prop: 'mediateCreatedName',
          name: '调解人',
          originProp: 'mediateCreatedName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'mediateCreatedTime',
          name: '调解时间',
          originProp: 'mediateCreatedTime',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.time
            }
          }
        },
        {
          prop: 'latestOperation',
          name: '最新操作',
          originProp: 'latestOperation',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(12)
            }
          }
        },
        buildDictionaryBySelect(dict.LITIGATION_TYPE, {
          prop: 'litigationType',
          name: '诉讼类型',
          originProp: 'litigationType',
          mod: {
            list: {}
          }
        }),
        buildDictionaryBySelect(logStatus, {
          prop: 'litigationStatus',
          name: '诉讼状态',
          originProp: 'litigationStatus',
          mod: {
            list: {}
          }
        }),
        buildDictionaryBySelect(hearStatus, {
          prop: 'hearStatus',
          name: '审理阶段',
          originProp: 'hearStatus',
          mod: {
            list: {},
            edit: {
              required: true
            },
            ...getEditMod('0')
          }
        }),
        {
          prop: 'filingCaseDate',
          name: '立案时间',
          originProp: 'filingCaseDate',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.date
            }
          }
        },
        buildDictionaryBySelect(dict.litigationJudgmentResultType, {
          prop: 'judgmentResultType',
          name: '判决结果',
          originProp: 'judgmentResultType',
          mod: {
            list: {}
          }
        }),
        buildDictionaryBySelect(dict.LITIGATION_REQUEST_TYPE, {
          prop: 'litigationRequestType',
          name: '诉讼请求',
          originProp: 'litigationRequestType',
          mod: {
            list: {}
          }
        }),
        buildDictionaryBySelect(baseSwitch, {
          prop: 'judgmentInstallmentFlag',
          name: '是否分期支付',
          originProp: 'judgmentInstallmentFlag',
          mod: {
            list: {}
          }
        }),
        {
          prop: 'judgmentAmount',
          name: '判决金额',
          originProp: 'judgmentAmount',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(6)
            }
          }
        },
        {
          prop: 'totalCollectionAmount',
          name: '判决已收金额',
          originProp: 'totalCollectionAmount',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(6)
            }
          }
        },
        {
          prop: 'residueRent',
          name: '剩余租金',
          originProp: 'residueRent',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(6)
            }
          }
        },
        {
          prop: 'residueCorpus',
          name: '剩余本金',
          originProp: 'residueCorpus',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(6)
            }
          }
        },
        {
          prop: 'residueInterest',
          name: '剩余利息',
          originProp: 'residueInterest',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(6)
            }
          }
        },
        {
          prop: 'penaltyOver',
          name: '逾期罚息',
          originProp: 'penaltyOver',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.getWidth(6)
            }
          }
        },
        {
          prop: 'updatedTime',
          name: '更新时间',
          originProp: 'updatedTime',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.time
            }
          }
        },
        {
          prop: 'updatedBy',
          name: '更新用户',
          originProp: 'updatedBy',
          originFrom: 'list',
          mod: {}
        },
        {
          prop: 'updatedName',
          name: '更新用户',
          originProp: 'updatedName',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.personnelName
            }
          }
        },
        {
          prop: 'createdTime',
          name: '添加时间',
          originProp: 'createdTime',
          originFrom: 'list',
          mod: {
            list: {
              width: listWidth.time
            }
          }
        },
        {
          prop: 'waitCollectRent',
          name: '待收租金',
          originProp: 'waitCollectRent',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ...getEditMod('0')
          }
        },
        {
          prop: 'waitCollectPrincipal',
          name: '待收本金',
          originProp: 'waitCollectPrincipal',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ...getEditMod('0')
          }
        },
        {
          prop: 'waitCollectInterest',
          name: '待收利息',
          originProp: 'waitCollectInterest',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              required: true,
              option: {
                min: 0,
                precision: 2
              }
            },
            ...getEditMod('0')
          }
        },
        {
          prop: 'litigationApplyDate',
          name: '诉讼申请时间',
          originProp: 'litigationApplyDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'date',
              required: true
            },
            ...getEditMod('0')
          }
        },
        {
          prop: 'filingCaseApplyPassDate',
          name: '立案申请通过时间',
          originProp: 'filingCaseApplyPassDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'date',
              required: true
            },
            ...getEditMod('10')
          }
        },
        {
          prop: 'filingCaseDate_edit',
          name: '立案时间',
          originProp: 'filingCaseDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'date',
              required: true
            },
            ...getEditMod('20')
          }
        },
        {
          prop: 'filingCaseNum',
          name: '案号',
          originProp: 'filingCaseNum',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              required: true
            },
            ...getEditMod('20')
          }
        },
        {
          prop: 'filingCaseJudge',
          name: '承办法官',
          originProp: 'filingCaseJudge',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'input',
              required: true
            },
            ...getEditMod('20')
          }
        },
        {
          prop: 'courtSessionDate',
          name: '开庭时间',
          originProp: 'courtSessionDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'date',
              required: true
            },
            ...getEditMod('30')
          }
        },
        buildDictionaryBySelect(dict.litigationJudgmentResultType, {
          prop: 'judgmentResultType_edit',
          name: '判决结果',
          originProp: 'judgmentResultType',
          mod: {
            edit: {
              required: true
            },
            ...getEditMod('40')
          }
        }),
        buildDictionaryBySelect(dict.litigationJudgmentExecutionPlanType, {
          prop: 'judgmentExecutionPlanType',
          name: '执行方案',
          originProp: 'judgmentExecutionPlanType',
          mod: {
            ...getEditMod('40')
          }
        }),
        {
          prop: 'judgmentDate',
          name: '判决时间',
          originProp: 'judgmentDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'date',
              required: true
            },
            ...getEditMod('40')
          }
        },
        {
          prop: 'judgmentAmount_edit',
          name: '判决金额',
          originProp: 'judgmentAmount',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'inputNumber',
              option: {
                min: 0,
                precision: 2
              },
              required: true
            },
            ...getEditMod('40')
          }
        },
        buildDictionaryBySelect(baseSwitch, {
          prop: 'judgmentInstallmentFlag_edit',
          name: '是否分期支付',
          originProp: 'judgmentInstallmentFlag',
          mod: {
            edit: {
              required: true
            },
            ...getEditMod('40')
          }
        }),
        {
          prop: 'fileList',
          name: '附件',
          originProp: 'fileList',
          originFrom: 'list',
          post(value) {
            return (value as any[]).map(item => item.data)
          },
          layout: {
            default: layoutParse.getData(1)
          },
          mod: {
            edit: {
              type: 'file',
              multiple: true,
              required: false,
              local: {
                target: {
                  props: {
                    complex: true
                  }
                }
              },
              option: {
                accept: config.file,
                upload (fileList) {
                  return uploadFile(fileList as unknown as File[], 'litigationLog')
                }
              }
            },
            ...getEditMod('40')
          }
        },
        {
          prop: 'closeCaseDate',
          name: '结案申请时间',
          originProp: 'closeCaseDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'date',
              required: true
            },
            ...getEditMod('100')
          }
        },
        buildDictionaryBySelect(dict.closeCaseReasonType, {
          prop: 'closeCaseReasonType',
          name: '结案原因',
          originProp: 'closeCaseReasonType',
          mod: {
            edit: {
              required: true
            },
            ...getEditMod('100')
          }
        }),
        {
          prop: 'closeCaseRemark',
          name: '结案说明',
          originProp: 'closeCaseRemark',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'textArea',
              required: true
            },
            ...getEditMod('100')
          }
        },
        {
          prop: 'closeCaseDate_finish',
          name: '结案申请时间',
          originProp: 'closeCaseDate',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'date',
              required: true
            },
            finish: {
              $target: 'edit'
            }
          }
        },
        buildDictionaryBySelect(dict.closeCaseReasonType, {
          prop: 'closeCaseReasonType_finish',
          name: '结案原因',
          originProp: 'closeCaseReasonType',
          mod: {
            edit: {
              required: true
            },
            finish: {
              $target: 'edit'
            }
          }
        }),
        {
          prop: 'closeCaseRemark_finish',
          name: '结案说明',
          originProp: 'closeCaseRemark',
          originFrom: 'list',
          mod: {
            edit: {
              type: 'textArea',
              required: true
            },
            finish: {
              $target: 'edit'
            }
          }
        },
        {
          prop: 'remark',
          name: '备注',
          originProp: 'remark',
          originFrom: 'list',
          mod: {
          }
        },
        {
          prop: 'createdBy',
          name: '创建人',
          originProp: 'createdBy',
          originFrom: 'list',
          mod: {
          }
        },
      ]
    }
  },
  $getData(this: LitigationLog) {
    return new Promise((resolve, reject) => {
      litigationApi.litigationLogList.require({
        ...this.$getSearch(),
        pageNo: this.$getPageData('current')!,
        pageSize: this.$getPageData('size')!
      }).then(res => {
        this.$formatList(res.data.data, res.data.totalCount)
        resolve({ status: 'success' })
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err)
        reject(err)
      })
    })
  }
})

const dictionary = litigationLog.$module.dictionary!

dictionary.$data.forEach(ditem => {
  if (ditem.$mod.edit) {
    let minIndex = -1
    for (const key in ditem.$mod) {
      const index = litigationLogFlowConfigList.indexOf(key)
      if (index !== -1) {
        if (minIndex > index || minIndex === -1) {
          minIndex = index
        }
      }
    }
    if (minIndex !== -1) {
      ditem.$mod.edit!.$setExtra('startKey', litigationLogFlowConfigList[minIndex])
    }
  }
})

dictionary.$getList = function(modName: string, dataMap?: Map<string, DictionaryData>, editKey?: string, edit?: boolean) {
  if (!dataMap) {
    dataMap = this.$data
  }
  const list: DictionaryData[] = []
  for (const ditem of dataMap.values()) {
    const mod = ditem.$getMod(modName) as DefaultEdit
    if (mod) {
      if (!editKey) {
        list.push(ditem)
      } else {
        if (!edit) {
          if (Number(modName) < Number(editKey)) {
            list.push(ditem)
          }
        } else {
          const startKey = mod.$getExtra('startKey')
          if (Number(startKey) === Number(editKey)) {
            list.push(ditem)
          }
        }
      }
    }
  }
  return list
}

export default litigationLog
